import React, { useState } from 'react';
import { ExpertiseCard } from '../../../constants/expertiseCardsData';
import { ClickableCardsSectionProps } from '../../../constants/interface/interface';

const ClickableCardsSection = ({ cards }: ClickableCardsSectionProps) => {
  const [activeCard, setActiveCard] = useState(cards[0]);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const toggleAccordion = (card: ExpertiseCard) => {
    if (activeCard && activeCard.id === card.id) {
      return;
    } else {
      setIsTransitioning(true);
      setTimeout(() => {
        setActiveCard(card);
        setIsTransitioning(false);
      }, 300);
    }
  };

  return (
    <div className="clickable-cards-section">
      <div className="cards-container">
        {cards.map((card) => (
          <div
            className={`card-accordion-item ${activeCard.id === card.id ? 'active' : ''}`}
            key={card.id}
          >
            <div
              className={`card ${activeCard.id === card.id ? 'active' : ''}`}
              onClick={() => toggleAccordion(card)}
            >
              <card.icon className={`icon-svg ${activeCard.id === card.id ? 'active' : ''}`} />
              <span className="expect-card-title">{card.title}</span>
            </div>
            <div className="content-container">
              <div className="content-list">
                <ul>
                  {card.content.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
              <div className="content-image">
                <img src={card.image} alt={card.title} />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className={`content-container-desktop ${isTransitioning ? 'transitioning' : ''}`}>
        <div className="content-list">
          <ul>
            {activeCard.content.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
        <div className="content-image">
          <img src={activeCard.image} alt={activeCard.title} />
        </div>
      </div>
    </div>
  );
};

export default ClickableCardsSection;
